import React, { useEffect, useRef } from "react"

import "../../style/users-tab.module.css"

export type SelectInputProps = {
  value: number | string,
  setValue?: React.ChangeEventHandler<HTMLInputElement>,
  onBlur?: React.FocusEventHandler<HTMLInputElement>,
  handleSelect: Function,
  selectOptions: Array<{ id: string, value: any, placeholder: string }>
}

const SelectInput = (props: SelectInputProps) => {
  const { value, setValue, onBlur, selectOptions, handleSelect } = props
  // Ref to input
  const inputRef = useRef<HTMLInputElement>(null)

  // Update input width according to the value
  useEffect(() => {
    const length = `${value}`.length

    if (length > 0 && inputRef.current) {
      inputRef.current.size = length
    }
  }, [value])

  return (
    <div className="select-input">
      <input
        className="select-input__input"
        type="text"
        placeholder="Current billing period"
        value={value}
        onChange={setValue}
        onBlur={onBlur}
        ref={inputRef}
        disabled
      />

      <img
        className="select-input__input"
        src="static/assets/dashboard/blue-caret-down.png"
        alt="Open Dropdown"
      />

      <div className="select-input__dropdown" style={{
        width: 'max-content'
      }}>
        {selectOptions.map((option) => {
          return (
            <span
              key={option.id}
              className="select-input__dropdown__item"
              onClick={() => handleSelect(option.value)}
            >{option.placeholder}</span>
          )
        })}
      </div>
    </div>
  )
}

export default SelectInput
